export default __webpack_public_path__ + "static/media/1648.aef53810.png";